import { useMemo } from 'react'

import {
  IconCircleCheck,
  IconCircleMinus,
  IconExclamationCircle,
  Icon,
} from '@tabler/icons-react'
import { Row, Col } from 'antd'
import styled from 'styled-components'

import {
  ChecklistDisplayBlock as ChecklistDisplayBlockType,
  CheckboxRadioField,
} from '../../types/blueprint'
import { DisplayDescription, Unanswered } from '../DisplayBlock.style'

import { Tag, TagProps } from '@/components/shared-components/BUI/Tag'
import { Flexbox } from '@/components/shared-components/Flexbox'

const Description = styled(DisplayDescription)`
  margin-bottom: 0.5rem;
`

export const noDesiredState = (item: CheckboxRadioField) =>
  item.desiredState === null ||
  item.desiredState === undefined ||
  item.desiredState?.[0] === null

type Status = [TagProps['variant'], Icon]

const getItemStatus = (item: CheckboxRadioField): Status => {
  if (noDesiredState(item)) {
    return [undefined, IconCircleMinus]
  }

  if (item.checked === item.desiredState) {
    return ['success', IconCircleCheck]
  }

  return ['danger', IconExclamationCircle]
}

type ChecklistTagProps = {
  item: ChecklistDisplayBlockType['checklist'][number]
}

const ChecklistResult: React.FC<ChecklistTagProps> = ({ item }) => {
  const [variant, Icon] = useMemo(() => getItemStatus(item), [item])

  return (
    <Tag
      icon={<Icon size={16} />}
      variant={variant}
      label={item.label}
      size="small"
      style={{ whiteSpace: 'break-spaces' }}
    />
  )
}

type Props = {
  block: ChecklistDisplayBlockType
}

export const ChecklistDisplayBlock: React.FC<Props> = ({ block }) => {
  const { description, checklist } = block

  return (
    <Row gutter={[24, 24]}>
      <Col xs={24}>
        {description && <Description>{description}</Description>}
        {checklist?.length ? (
          <Flexbox flexDirection="column" alignItems="flex-start" gap="0.5rem">
            {checklist?.map((item) => (
              <ChecklistResult
                key={`${item.label}-${item.value}`}
                item={item}
              />
            ))}
          </Flexbox>
        ) : (
          <Unanswered />
        )}
      </Col>
    </Row>
  )
}
